// import components
import { styled, Typography, TypographyProps } from '@mui/material';

export const StyledTextWithIconCellTypography = styled(
  Typography
)<TypographyProps>(({ theme }) => ({
  fontSize: '12px',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  textAlign: 'center',
  ':hover': {
    cursor: 'pointer'
  }
}));
